import React from 'react';
import styles from './StarRating.module.css';

const StarRating = ({ rating, maxRating = 5, size = 'medium', showNumber = false }) => {
  const numericRating = typeof rating === 'string' ? parseFloat(rating) : rating;
  const validRating = isNaN(numericRating) ? 0 : Math.max(0, Math.min(maxRating, numericRating));

  const renderStars = () => {
    const stars = [];
    const fullStars = Math.floor(validRating);
    const hasHalfStar = validRating % 1 >= 0.5;

    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <span key={i} className={`${styles.star} ${styles.filled}`}>
          ⭐
        </span>
      );
    }

    if (hasHalfStar && fullStars < maxRating) {
      stars.push(
        <span key="half" className={`${styles.star} ${styles.half}`}>
          ⭐
        </span>
      );
    }

    const emptyStars = maxRating - fullStars - (hasHalfStar ? 1 : 0);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(
        <span key={`empty-${i}`} className={`${styles.star} ${styles.empty}`}>
          ⭐
        </span>
      );
    }

    return stars;
  };

  return (
    <div className={`${styles.starRating} ${styles[size]}`}>
      <div className={styles.stars}>
        {renderStars()}
      </div>
      {showNumber && (
        <span className={styles.ratingNumber}>
          {validRating.toFixed(1)}
        </span>
      )}
    </div>
  );
};

export default StarRating;

